(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-recommendations"]) return;
  try {
    
  const handleIntersection = (entries, observer) => {
    if (!entries[0].isIntersecting) return;

    observer.unobserve(productRecommendationsSection);

    const url = productRecommendationsSection.dataset.url;

    fetch(url)
      .then((response) => response.text())
      .then((text) => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('.product-recommendations');

        if (recommendations && recommendations.innerHTML.trim().length) {
          productRecommendationsSection.innerHTML = recommendations.innerHTML;
        }
      })
      .catch((e) => {
        console.error(e);
      });
  };

  const productRecommendationsSection = document.querySelector('.product-recommendations');
  const observer = new IntersectionObserver(handleIntersection, { rootMargin: '0px 0px 200px 0px' });

  observer.observe(productRecommendationsSection);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-details"]) return;
  try {
    
  // Variant Picker
  class VariantPicker extends HTMLElement {
    constructor() {
      super();
      const options = this.querySelectorAll('.product-details-section-filter');
      options.forEach((option) => {
        option.addEventListener('click', function (event) {
          event.preventDefault();
          event.stopPropagation();

          const variantId = this.getAttribute('data-variant-id');
          const containerSectionId = this.getAttribute('data-container-section-id');
          const url = new URL(this.href);

          // Get the dynamic info
          fetch(url)
            .then((response) => response.text())
            .then((data) => {
              const parser = new DOMParser();
              const doc = parser.parseFromString(data, 'text/html');

              const newSection = doc.querySelector(`#shopify-section-${containerSectionId}`);
              const currentSection = document.querySelector(`#shopify-section-${containerSectionId}`);

              if (newSection && currentSection) {
                currentSection.innerHTML = newSection.innerHTML;
              }

              // Slider
              const sliderSection = document.querySelector('.product-section');
              if (sliderSection) {
                const sliderSectionId = sliderSection.getAttribute('id');
                if (sliderSectionId) {
                  const newSliderSection = doc.querySelector(`#${sliderSectionId}`);

                  if (newSliderSection) {
                    sliderSection.innerHTML = newSliderSection.innerHTML;
                  }
                }
              }

              // Update the URL without reloading the page
              window.history.pushState({}, '', url);
            })
            .catch((error) => console.error('Error fetching variant:', error));
        });
      });
    }
  }
  customElements.define('variant-picker', VariantPicker);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  const productRecommendationsSection = document.querySelector('.product-recommendations');
  const productRecommendationsWrapper = document.querySelector('.product-recommendations-section');
  const productRecommendationsFallback = document.querySelector('.product-recommendations-fallback');

  const handleIntersection = (entries, observer) => {
    if (!entries[0].isIntersecting) return;

    observer.unobserve(productRecommendationsSection);

    const url = productRecommendationsSection.dataset.url;

    fetch(url)
      .then((response) => response.text())
      .then((text) => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('.product-recommendations');
        const recItems = recommendations ? recommendations.querySelectorAll('.product-recommendations-item') : [];
        const fallbackItems = productRecommendationsFallback ? productRecommendationsFallback.querySelectorAll('.product-recommendations-item') : [];

        if (recItems.length >= 3) {
          productRecommendationsSection.innerHTML = recommendations.innerHTML;
        } else if (recItems.length > 0) {
          // Backfill from fallback to reach 3
          productRecommendationsSection.innerHTML = '';
          recItems.forEach(item => productRecommendationsSection.appendChild(item.cloneNode(true)));
          let added = recItems.length;
          for (let i = 0; i < fallbackItems.length && added < 3; i++) {
            productRecommendationsSection.appendChild(fallbackItems[i].cloneNode(true));
            added++;
          }
        } else if (fallbackItems.length) {
          productRecommendationsSection.innerHTML = productRecommendationsFallback.innerHTML;
        } else if (productRecommendationsWrapper) {
          productRecommendationsWrapper.style.display = 'none';
        }
      })
      .catch((e) => {
        console.error(e);
        const fallback = productRecommendationsFallback;
        if (fallback && fallback.innerHTML.trim().length) {
          productRecommendationsSection.innerHTML = fallback.innerHTML;
        } else if (productRecommendationsWrapper) {
          productRecommendationsWrapper.style.display = 'none';
        }
      });
  };

  const observer = new IntersectionObserver(handleIntersection, { rootMargin: '0px 0px 200px 0px' });

  observer.observe(productRecommendationsSection);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  function initQuantitySelector() {
    const quantityOptions = document.querySelectorAll('.product-quantity-option');

    quantityOptions.forEach(option => {
      option.addEventListener('click', (e) => {
        e.preventDefault();

        const quantityValue = option.getAttribute('data-quantity-value');
        const quantitySelector = option.closest('.product-quantity-selector');
        const quantityInput = quantitySelector.querySelector('[data-quantity-input]');

        // Remove active class from all quantity options
        quantitySelector.querySelectorAll('.product-quantity-option').forEach(opt => {
          opt.classList.remove('active');
        });

        // Add active class to clicked option
        option.classList.add('active');

        // Update hidden input value
        if (quantityInput) {
          quantityInput.value = quantityValue;
        }
      });
    });
  }

  function initQuantityDropdown() {
    const selects = document.querySelectorAll('[data-quantity-select]');
    selects.forEach(select => {
      select.addEventListener('change', () => {
        const container = select.closest('[data-quantity-selector]');
        const quantityInput = container.querySelector('[data-quantity-input]');
        const valueDisplay = container.querySelector('[data-quantity-value-display]');
        if (quantityInput) {
          quantityInput.value = select.value;
        }
        if (valueDisplay) {
          valueDisplay.textContent = select.value;
        }
      });
    });
  }

  function initVariantSelector() {
    const variantOptions = document.querySelectorAll('.product-variant-option');

    variantOptions.forEach(option => {
      option.addEventListener('click', (e) => {
        e.preventDefault();

        const variantId = option.getAttribute('data-variant-id');
        const featuredImageId = option.getAttribute('data-featured-image-id');
        const sectionId = option.getAttribute('data-section-id');
        const url = new URL(option.href);
        const parentSelector = option.closest('.product-variant-selector');

        // Mark active within the same option group
        if (parentSelector) {
          parentSelector.querySelectorAll('.product-variant-option').forEach(opt => opt.classList.remove('active'));
        }
        option.classList.add('active');

        fetch(url)
          .then(response => response.text())
          .then(data => {
            const parser = new DOMParser();
            const doc = parser.parseFromString(data, 'text/html');

            const newSection = doc.querySelector(`#shopify-section-${sectionId}`);
            const currentSection = document.querySelector(`#shopify-section-${sectionId}`);

            if (newSection && currentSection) {
              currentSection.innerHTML = newSection.innerHTML;
              initVariantSelector();
              initQuantitySelector();
              initQuantityDropdown();
              initQuoteButton();
              initAddToCartButton();
              initMobileCarousel();
              initZoomOverlay();
            }

            window.history.pushState({}, '', url);
          })
          .catch(error => console.error('Error fetching variant:', error));
      });
    });
  }

  function initQuoteButton() {
    const quoteButtons = document.querySelectorAll('[data-quote-button]');

    quoteButtons.forEach(button => {
      const newButton = button.cloneNode(true);
      button.parentNode.replaceChild(newButton, button);

      newButton.addEventListener('click', (e) => {
        e.preventDefault();

        let variantId = '';

        const variantInput = document.querySelector('.product-variant-id');
        if (variantInput && variantInput.value) {
          variantId = variantInput.value;
        }

        if (!variantId) {
          variantId = newButton.getAttribute('data-variant-id');
        }

        // Get selected quantity
        const quantityInput = document.querySelector('[data-quantity-input]');
        const quantity = quantityInput ? quantityInput.value : 1;

        if (variantId) {
          const formData = new FormData();
          formData.append('id', variantId);
          formData.append('quantity', quantity);
          formData.append('properties[_quote]', 'true');

          fetch('/cart/add.js', {
            method: 'POST',
            body: formData
          })
          .then(response => {
            if (!response.ok) {
              throw new Error('Network response was not ok');
            }
            return response.json();
          })
          .then(data => {
            window.location.href = '/cart';
          })
          .catch(error => {
            console.error('Error adding quote to cart:', error);
            alert('Error adding to cart. Please try again.');
          });
        } else {
          alert('Please select a product variant.');
        }
      });
    });
  }

  function initAddToCartButton() {
    const addToCartButtons = document.querySelectorAll('[data-add-to-cart-button]');

    addToCartButtons.forEach(button => {
      const newButton = button.cloneNode(true);
      button.parentNode.replaceChild(newButton, button);

      newButton.addEventListener('click', (e) => {
        e.preventDefault();

        let variantId = newButton.getAttribute('data-variant-id');

        // Get selected quantity
        const quantityInput = document.querySelector('[data-quantity-input]');
        const quantity = quantityInput ? quantityInput.value : 1;

        if (variantId) {
          const formData = new FormData();
          formData.append('id', variantId);
          formData.append('quantity', quantity);

          fetch('/cart/add.js', {
            method: 'POST',
            body: formData
          })
          .then(response => {
            if (!response.ok) {
              throw new Error('Network response was not ok');
            }
            return response.json();
          })
          .then(data => {
            window.location.href = '/cart';
          })
          .catch(error => {
            console.error('Error adding to cart:', error);
            alert('Error adding to cart. Please try again.');
          });
        } else {
          alert('Please select a product variant.');
        }
      });
    });
  }

  function initMobileCarousel() {
    const track = document.querySelector('[data-carousel-track]');
    if (!track) return;

    let isDown = false;
    let startX;
    let scrollLeft;

    track.addEventListener('mousedown', (e) => {
      isDown = true;
      startX = e.pageX - track.offsetLeft;
      scrollLeft = track.scrollLeft;
    });

    track.addEventListener('mouseleave', () => {
      isDown = false;
    });

    track.addEventListener('mouseup', () => {
      isDown = false;
    });

    track.addEventListener('mousemove', (e) => {
      if (!isDown) return;
      e.preventDefault();
      const x = e.pageX - track.offsetLeft;
      const walk = (x - startX) * 2;
      track.scrollLeft = scrollLeft - walk;
    });

    let touchStartX = 0;
    let touchScrollLeft = 0;

    track.addEventListener('touchstart', (e) => {
      touchStartX = e.touches[0].pageX - track.offsetLeft;
      touchScrollLeft = track.scrollLeft;
    });

    track.addEventListener('touchmove', (e) => {
      const x = e.touches[0].pageX - track.offsetLeft;
      const walk = (x - touchStartX) * 2;
      track.scrollLeft = touchScrollLeft - walk;
    });
  }

  function initZoomOverlay() {
    const zoomOverlay = document.querySelector('[data-zoom-overlay]');
    const zoomImageTarget = document.querySelector('[data-zoom-image-target]');
    const zoomClose = document.querySelector('[data-zoom-close]');
    const zoomContainer = document.querySelector('.product-zoom-container');

    if (!zoomOverlay || !zoomImageTarget) return;

    let allImages = [];
    let currentImageIndex = 0;

    const loadImages = () => {
      const triggers = document.querySelectorAll('[data-zoom-trigger]');
      allImages = [];

      triggers.forEach(trigger => {
        const img = trigger.querySelector('img');
        if (img) {
          allImages.push({
            src: img.getAttribute('data-zoom-image') || img.src,
            alt: img.alt
          });
        }
      });
    };

    loadImages();

    const closeZoom = (e) => {
      if (e) {
        e.preventDefault();
        e.stopPropagation();
      }
      zoomOverlay.classList.remove('active');
      document.body.style.overflow = '';
    };

    const openZoom = (imageSrc, imageAlt) => {
      currentImageIndex = allImages.findIndex(img => img.src === imageSrc);
      if (currentImageIndex === -1) currentImageIndex = 0;

      zoomImageTarget.src = imageSrc;
      zoomImageTarget.alt = imageAlt;
      zoomOverlay.classList.add('active');
      document.body.style.overflow = 'hidden';
    };

    const showImage = (index) => {
      if (allImages.length === 0) return;

      if (index < 0) {
        index = allImages.length - 1;
      } else if (index >= allImages.length) {
        index = 0;
      }

      currentImageIndex = index;
      const image = allImages[currentImageIndex];

      zoomImageTarget.src = image.src;
      zoomImageTarget.alt = image.alt;
    };

    const nextImage = () => {
      showImage(currentImageIndex + 1);
    };

    const prevImage = () => {
      showImage(currentImageIndex - 1);
    };

    const zoomTriggers = document.querySelectorAll('[data-zoom-trigger]');

    zoomTriggers.forEach((trigger, index) => {
      const newTrigger = trigger.cloneNode(true);
      trigger.parentNode.replaceChild(newTrigger, trigger);

      newTrigger.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();

        const img = newTrigger.querySelector('img');
        if (!img) return;

        const zoomSrc = img.getAttribute('data-zoom-image') || img.src;
        const alt = img.alt;

        openZoom(zoomSrc, alt);
      });
    });

    if (zoomClose) {
      zoomClose.addEventListener('click', (e) => {
        closeZoom(e);
      }, { once: false });
    }

    zoomOverlay.addEventListener('click', (e) => {
      if (e.target === zoomOverlay) {
        closeZoom(e);
      }
    });

    if (zoomContainer) {
      zoomContainer.addEventListener('click', (e) => {
        if (e.target === zoomContainer) {
          closeZoom(e);
        }
      });
    }

    if (zoomImageTarget) {
      zoomImageTarget.addEventListener('click', (e) => {
        closeZoom(e);
      });
    }

    document.addEventListener('keydown', (e) => {
      if (!zoomOverlay.classList.contains('active')) return;

      switch(e.key) {
        case 'Escape':
          closeZoom(e);
          break;
        case 'ArrowRight':
          e.preventDefault();
          nextImage();
          break;
        case 'ArrowLeft':
          e.preventDefault();
          prevImage();
          break;
      }
    });

    let touchStartX = 0;
    let touchEndX = 0;

    zoomImageTarget.addEventListener('touchstart', (e) => {
      touchStartX = e.changedTouches[0].screenX;
    }, { passive: true });

    zoomImageTarget.addEventListener('touchend', (e) => {
      touchEndX = e.changedTouches[0].screenX;
      handleSwipe();
    }, { passive: true });

    const handleSwipe = () => {
      const swipeThreshold = 50;
      const diff = touchStartX - touchEndX;

      if (Math.abs(diff) > swipeThreshold) {
        if (diff > 0) {
          nextImage();
        } else {
          prevImage();
        }
      }
    };
  }

  document.addEventListener('DOMContentLoaded', () => {
    initVariantSelector();
    initQuantitySelector();
    initQuantityDropdown();
    initQuoteButton();
    initAddToCartButton();
    initMobileCarousel();
    initZoomOverlay();
  });

  if (document.readyState !== 'loading') {
    initVariantSelector();
    initQuantitySelector();
    initQuantityDropdown();
    initQuoteButton();
    initAddToCartButton();
    initMobileCarousel();
    initZoomOverlay();
  }

  } catch(e) { console.error(e); }
})();
})();
